/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_Needs_ExportInputs */

const cs_portals_verify_needs_export = /** @type {(inputs: Portals_Verify_Needs_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Před ověřením publikace nejdřív zapněte export na portál`)
};

const en_portals_verify_needs_export = /** @type {(inputs: Portals_Verify_Needs_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable the portal export before verifying publication`)
};

/**
* | output |
* | --- |
* | "Enable the portal export before verifying publication" |
*
* @param {Portals_Verify_Needs_ExportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_needs_export = /** @type {((inputs?: Portals_Verify_Needs_ExportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_Needs_ExportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_needs_export(inputs)
	return cs_portals_verify_needs_export(inputs)
});